import { createAction, handleActions } from 'redux-actions'

const startFetching = createAction('SCREENS/PLANNER/SUBCONTRACTOR_POPOVER/START_FETCHING')
const finishFetching = createAction('SCREENS/PLANNER/SUBCONTRACTOR_POPOVER/FINISH_FETCHING')
const resetFetching = createAction('SCREENS/PLANNER/SUBCONTRACTOR_POPOVER/RESET_FETCHING')

const defaultState = false

const reducer = handleActions(
  {
    [startFetching]: () => true,
    [finishFetching]: () => false,
    [resetFetching]: () => false,
  },
  defaultState,
)

export { startFetching, finishFetching, resetFetching, reducer }
